import { Icon } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { openModal } from '~/redux/features/uiState/uiStateSlice';
import { CardItemProp } from '~myAccount/pages/UserCards/types';
import { useAppDispatch } from '~/redux/hooks';
import { createExpiryDate } from '~/utils';

export default function MobileCardItem({
  card,
  onDeleteItem,
  isLast,
}: CardItemProp) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('app');
  return (
    <div
      className={` ${!isLast ? 'border-b border-gray pb-2x' : ''} py-3x px-2x`}
    >
      <div className="flex gap-2x justify-between ">
        <div className="flex flex-col gap-0.5x">
          <div className="flex  gap-x">
            <div className="flex element-center">
              <i
                className={`inline-block bg-cover w-[32px] h-[24px] ${card.card_brand.toLowerCase()}-icon `}
              />
            </div>
            <p className="text-title_4 text-gray__dark_2">{`XXXX-${card.card_last4}`}</p>
          </div>
          <p className="text-caption text-gray__dark_1">
            {card.card_holder_name}
          </p>
          <p className="text-caption text-gray__dark_1">
            {t('expiresIn')}
            <span className="text-body_2 text-gray__dark_2">
              {createExpiryDate({
                year: card.expiry_year,
                month: card.expiry_month,
              })}
            </span>
          </p>
        </div>
        <button
          className="flex justify-end "
          onClick={() => {
            onDeleteItem(card.id);
            dispatch(openModal('deleteUserCard'));
          }}
          type="button"
        >
          <Icon name="delete" className="text-red_dark" />
        </button>
      </div>
    </div>
  );
}
